import { createSlice } from '@reduxjs/toolkit';

export const ConnectionState = {
  CLOSED: 'closed',
  CONFIGURED: 'configured',
  CONNECTED: 'connected',
  FAILED: 'failed',
  INITIALIZED: 'initialized',
  RECONNECTING: 'reconnecting',
  UNINITIALIZED: 'uninitialized', // initial state
};

export const connectionSlice = createSlice({
  name: 'connection',
  initialState: {
    connectionState: ConnectionState.UNINITIALIZED,
    peerReconnecting: false,
  },
  reducers: {
    setConnectionState: (state, action) => {
      state.connectionState = action.payload;
    },
    setPeerReconnecting: (state, action) => {
      state.peerReconnecting = action.payload;
    },
  },
});

export const { setConnectionState, setPeerReconnecting } =
  connectionSlice.actions;

export default connectionSlice.reducer;
